import React from 'react';
import PropTypes from 'prop-types';

import { AmountLineJustified, FormatMessage } from '../core';
import { itemConfirmationSummaryMessages } from './confirmationMessages';

export const ItemConfirmationSummary = ({ quantity, subTotal, shipping, fees, discount, total, currency }) => (
    <div className="item-confirmation-summary">
        <h3>
            <FormatMessage
                intlMessage={itemConfirmationSummaryMessages.heading}
                className="item-confirmation-summary-heading"
            />
        </h3>
        <AmountLineJustified
            labelMessage={{ ...itemConfirmationSummaryMessages.subtotalLabel, values: { quantity } }}
            amount={subTotal}
            currency={currency}
        />
        {shipping !== 0 && (
            <AmountLineJustified
                labelMessage={itemConfirmationSummaryMessages.shippingLabel}
                amount={shipping}
                currency={currency}
            />
        )}
        {fees !== 0 && (
            <AmountLineJustified
                labelMessage={itemConfirmationSummaryMessages.feesLabel}
                amount={fees}
                currency={currency}
            />
        )}
        {discount !== 0 && (
            <AmountLineJustified
                labelMessage={itemConfirmationSummaryMessages.discountsLabel}
                amount={-discount}
                currency={currency}
            />
        )}
        <div className="item-confirmation-summary-total">
            <AmountLineJustified
                labelMessage={itemConfirmationSummaryMessages.totalLabel}
                amount={total}
                currency={currency}
            />
        </div>
    </div>
);

ItemConfirmationSummary.defaultProps = {
    shipping: 0,
    fees: 0,
    discount: 0,
    currency: 'USD'
};

ItemConfirmationSummary.propTypes = {
    quantity: PropTypes.number.isRequired,
    subTotal: PropTypes.number.isRequired,
    shipping: PropTypes.number,
    fees: PropTypes.number,
    discount: PropTypes.number,
    total: PropTypes.number.isRequired,
    currency: PropTypes.string
};
